import * as v from "valibot";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import {
  CorasFooter,
  CorasSearchPage,
  CorasNavBar,
} from "@coras-io/web-components-react";
import {
  SupportedCurrencies,
  SupportedLocales,
} from "@coras-io/web-components/types";
import { config, site } from "../config.ts";
import { handleParamsUpdate } from "../utils.ts";

const routeParamsSchema = v.object({
  locale: v.optional(v.picklist(config.locales), config.locale),
  currency: v.optional(v.picklist(config.currencies), config.currency),
});

const searchParamsSchema = v.object({
  city: v.optional(v.string()),
  country: v.optional(v.string()),
  startDate: v.optional(v.string()),
  search: v.optional(v.string()),
});

export const Route = createFileRoute("/$locale/$currency/search")({
  component: SearchPageComponent,
  beforeLoad: ({ params }) => {
    if (!v.safeParse(routeParamsSchema, params).success) {
      throw redirect({
        replace: true,
        to: "/$locale/$currency",
        params: {
          locale: config.locale,
          currency: config.currency,
        },
      });
    }
  },
  params: { parse: (rawParams) => v.parse(routeParamsSchema, rawParams) },
  validateSearch: searchParamsSchema,
  head: () => {
    return {
      meta: [
        {
          title: site.title,
        },
        {
          name: "description",
          content: site.description,
        },
      ],
    };
  },
});

function SearchPageComponent() {
  const { locale, currency } = Route.useParams();
  const { city, country, startDate, search } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  // @ts-ignore
  const onParamsUpdate = (params) => {
    return handleParamsUpdate(navigate, params);
  };

  const goToHomePage = async () => {
    await navigate({
      resetScroll: true,
      to: `/${locale}/${currency}`,
    });
  };

  return (
    <CorasSearchPage
      apiHost={import.meta.env.VITE_API_HOST}
      distributorID={import.meta.env.VITE_DISTRIBUTOR_ID}
      locales={config.locales}
      locale={locale as SupportedLocales}
      currencies={config.currencies}
      currency={currency as SupportedCurrencies}
      assetsURL={import.meta.env.VITE_ASSETS_URL}
      search={search || ""}
      startDate={startDate}
      city={city || ""}
      country={country || ""}
      onParamsUpdate={onParamsUpdate}
    >
      <CorasNavBar slot="navbar">
        <img
          className="logo"
          src={site.logo}
          alt={site.logo}
          slot="logo"
          onClick={goToHomePage}
        />
      </CorasNavBar>
      <CorasFooter slot="footer" />
    </CorasSearchPage>
  );
}
